module.exports = __webpack_public_path__ + "static/media/driver-and-vehicle-checklist.a0b3b9a1.pdf";